export default "__VITE_ASSET__BBKjSEy9__"